<app-message-empty
    [title]="'Query could not be executed'"
    [subtitle]="'Please review the query you want to execute'"
    [icon]="'../../assets/img/open-box.png'"></app-message-empty>
